import GridIcon from "../../../../../assets/svg/grid-icon";
import ListViewIcon from "../../../../../assets/svg/list-view-icon";

const VIEW_OPTIONS = [
  { id: "grid" as const, icon: GridIcon, label: "Kanban" },
  { id: "list" as const, icon: ListViewIcon, label: "List" },
];

interface ViewToggleProps {
  view: "grid" | "list";
  onViewChange: (view: "grid" | "list") => void;
  viewOptions?: {
    id: "grid" | "list";
    icon: React.ElementType;
    label: string;
  }[];
}

export const ViewToggle = ({
  view,
  onViewChange,
  viewOptions = VIEW_OPTIONS,
}: ViewToggleProps) => {
  return (
    <div className="w-max flex items-center p-0.5 border border-border-gray dark:border-border-gray-dk rounded-md shrink-0">
      {viewOptions.map(({ id, icon: Icon, label }) => (
        <button
          key={id}
          className={`pl-1 pr-2 py-0.5 cursor-pointer rounded-sm ${
            view === id && "bg-verba-indigo dark:bg-verba-indigo-dk"
          }`}
          onClick={() => onViewChange(id)}
          title={label}
        >
          <div className="flex items-center gap-0.5">
            <Icon
              className={`w-[18px] h-[18px] ${
                view === id
                  ? "text-pure-white dark:text-pure-white-dk"
                  : "text-verba-indigo dark:text-verba-indigo-dk"
              }`}
            />
            <span
              className={`text-md whitespace-nowrap ${
                view === id
                  ? "font-semibold text-pure-white dark:text-pure-white-dk"
                  : "font-normal text-verba-indigo dark:text-verba-indigo-dk"
              }`}
            >
              {label}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};
